module.exports = __webpack_public_path__ + "static/img/quotation_left.cbd8597a.svg";